////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const itemCatalog = {
	resetDataItemCatalog: () => ({
		type: ActionsTypes.RESET_DATA_ITEM_CATALOG,
	}),
	getItemCatalog: (filters = {}, queryParams = { page: '0', size: '50', sort: 'name', order: 'asc' }) => ({
		type: ActionsTypes.GET_ITEM_CATALOG,
		payload: {
			filters,
			queryParams,
		},
	}),
	getItemCatalogSuccess: (data) => ({
		type: ActionsTypes.GET_ITEM_CATALOG_SUCCESS,
		payload: {
			data,
		},
	}),
	getItemCatalogFailure: (error) => ({
		type: ActionsTypes.GET_ITEM_CATALOG_FAILURE,
		payload: {
			error,
		},
	}),
	setSalesByCodeArticle: (itemCatalog) => ({
		type: ActionsTypes.SET_ITEM_CATALOG_SALESBYCODE,
		payload: {
			itemCatalog,
		},
	}),
	getStocksFiltersInfo: (filtersInfos) => ({
		type: ActionsTypes.GET_ITEM_CATALOG_FILTERS_STOCKS,
		payload: {
			filtersInfos,
		},
	}),
	setSaleByArticle: (itemCatalog) => ({
		type: ActionsTypes.SET_ITEM_CATALOG_SALEBYARTICLE,
		payload: {
			itemCatalog,
		},
	}),
	getSaleOrderByCode: (id) => ({
		type: ActionsTypes.GET_SALE_ORDER_BY_CODE,
		payload: {
			id,
		},
	}),
	getSaleOrderByCodeSuccess: (item) => ({
		type: ActionsTypes.GET_SALE_ORDER_BY_CODE_SUCCESS,
		payload: {
			item,
		},
	}),
	getSaleOrderByCodeFailure: (error) => ({
		type: ActionsTypes.GET_SALE_ORDER_BY_CODE_FAILURE,
		payload: {
			error,
		},
	}),
	postCreateCode: (bodyData) => ({
		type: ActionsTypes.POST_CREATE_CODE,
		payload: {
			bodyData,
		},
	}),
	postCreateCodeSuccess: (item) => ({
		type: ActionsTypes.POST_CREATE_CODE_SUCCESS,
		payload: {
			item,
		},
	}),
	postCreateCodeFailure: (error) => ({
		type: ActionsTypes.POST_CREATE_CODE_FAILURE,
		payload: {
			error,
		},
	}),

	postSendCode: (id, slug, urlParam = null, email = null, bodyData = null) => ({
		type: ActionsTypes.POST_SEND_CODE,
		payload: {
			id,
			slug,
			urlParam,
			email,
			bodyData,
		},
	}),
	postSendCodeSuccess: (item) => ({
		type: ActionsTypes.POST_SEND_CODE_SUCCESS,
		payload: {
			item,
		},
	}),
	postSendCodeFailure: (error) => ({
		type: ActionsTypes.POST_SEND_CODE_FAILURE,
		payload: {
			error,
		},
	}),
	setIsClosedModal: () => ({
		type: ActionsTypes.SET_IS_CLOSED_MODAL,
	}),
	setIsToUpdate: () => ({
		type: ActionsTypes.SET_IS_TO_UPDATE,
	}),
}

export default itemCatalog
